export default "__VITE_ASSET__yfrh2CW___"